// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b7d65693","455":"97eb6ed1","977":"6b532509"}[chunkId] + ".chunk.js";
};